<template>
  <div class="customer-wrp">
    <section>
      <div class="search-wrp">
        <div class="search-ipt">
          <div class="search-input">
            <input type="text" placeholder="客户名称" v-model="customerInput">
          </div>
          <div class="search-icon" @click="getList">
            搜索
          </div>
        </div>
      </div>
      <van-pull-refresh v-model="refreshing" @refresh="getList">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div class="customer" v-for="(item, index) in customerList" :key="index" @click="customerDetail(item.merchantArchivesVo.id)">
            <p class="tax-no">{{item.merchantArchivesVo.taxNo}}</p>
            <p class="company-name">{{item.merchantArchivesVo.company}}</p>
            <p class="address">{{item.merchantArchivesVo.address}}</p>
            <div class="operation">
              <div class="operation-wrp" v-if="!isOpening">
                <div class="edit" @click.stop="editCustomer(item.merchantArchivesVo.id)">编辑</div>
                <div class="delete" @click.stop="deleteCustomer(item.merchantArchivesVo.id)">删除</div>
              </div>
              <div class="operation-wrp" v-else>
                <div class="edit" @click.stop="selectCustomer(item.merchantArchivesVo)">使用</div>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </section>
    <div v-if="!isOpening" class="float-btn" @click="addCustomer">新建客户</div>
  </div>
</template>

<script>
import { customerRequest } from '@services'
import { aesDoEncrypt } from '@utils/basicUtil'
import {
  Notify,
  PullRefresh,
  List
} from 'vant'

export default {
  data () {
    return {
      customerInput: '',
      customerList: [
      ],
      pageParams: {
        size: 10,
        current: 1
      },
      total: 0,
      refreshing: false,
      loading: false,
      finished: false,
      isOpening: false
    }
  },
  mounted () {
    const { isOpening } = this.$route.query
    if (isOpening) {
      this.isOpening = true
    } else {
      this.isOpening = false
    }
    this.getList()
  },
  computed: {
  },
  methods: {
    getList () {
      this.refreshing = true
      this.customerList = []
      this.pageParams.current = 1
      this.getCustomerList()
    },
    async getCustomerList () {
      if (this.refreshing) {
        this.refreshing = false
      }
      this.loading = true
      const data = await customerRequest.customer.list({
        ...this.pageParams,
        company: this.customerInput
      })
      if (data.success) {
        if (data.result.records) {
          this.customerList = [...this.customerList, ...data.result.records]
          if (Number(data.result.size) > data.result.records.length) {
            this.finished = true
          } else {
            this.finished = false
          }
        } else {
          this.finished = true
        }
      } else {
        Notify({ type: 'danger', message: data.message })
      }
      this.loading = false
    },
    onLoad () {
      this.pageParams.current++
      this.getCustomerList()
    },
    editCustomer (id) {
      this.$router.push(`/customer/edit/${id}`)
    },
    splitString (str, isEnd = false) {
      // if (str) {
      //   return str.split(' ')[isEnd ? str.split(' ').length - 1 : 0]
      // }
      return str
    },
    selectCustomer (item) {
      const info = {
        address: this.splitString(item.address),
        bankName: this.splitString(item.bankName),
        name: item.company,
        taxNo: item.taxNo
      }
      sessionStorage.customInfo = aesDoEncrypt(info)
      this.$router.go(-1)
    },
    async deleteCustomer (id) {
      const data = await customerRequest.customer.delete({ id })
      if (data.success) {
        Notify({ type: 'success', message: '删除成功' })
        this.getList()
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    },
    customerDetail (id) {
      if (this.isOpening) return
      this.$router.push(`/customer/detail/${id}`)
    },
    addCustomer () {
      this.$router.push(`/customer/add`)
    }
  },
  components: {
    [PullRefresh.name]: PullRefresh,
    [List.name]: List

  }
}
</script>

<style lang="less" scoped src="./style.less"/>
